<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">R&D Labs & Maker Spaces</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>These are developed on two models</p>
                                </div>

                                <div class="detail-section wow fadeInUp" data-wow-delay=".4s">
                                    <h4>Tribinnov Labs</h4>
                                    <p>These are our research labs, built from scratch with the goal of harnessing R&D
                                        on the continent, and enable collaborations with our internal and external
                                        researchers to get into various result-oriented research.</p>

                                    <p>The R&D labs focus on our chosen industries, such as the water research lab,
                                        clean energy labs, AI & Robotics labs and more.</p>

                                    <p>The Maker Spaces however are microfactories for brainstorming, product
                                        development and prototyping of hardwate designs.
                                    </p>

                                    <p>
                                        Our goal is to establish 1 central lab per state in Nigeria and replicate in
                                        other countries, while we leverage campuses to develop maker spaces.
                                    </p>

                                    <p>
                                        They make money by conducting high level experiments, analysis and many more and
                                        they get standard licenses from regulation bodies to be operated.
                                    </p>

                                    <p>
                                        <a href="mailto:hello@tribinnovafrica.com">Partner with us to build a lab</a>
                                    </p>

                                </div>

                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <h4>Laplat.AI</h4>

                                    <p>
                                        This is a Pan African and Global Lab Network, targeting 10,000+ laboratories and
                                        facilities, with a target of over 100, 000 equipment, machineries and
                                        experimental listing.
                                    </p>

                                    <p>
                                        With high degree Geo location and several thousands of possible tests, analysis
                                        and prototyping, any researcher can access facilities and conduct experiments
                                        across the continent.
                                    </p>

                                    <ul class="list">
                                        <li>Labs for Research</li>
                                        <li>Facilities for Prototyping and Manufacturing</li>
                                        <li>Digital Manufacturing quoting and Management Tools.</li>
                                    </ul>

                                    <a href="https://app.tribinnovafrica.com/register?type=research"></a>
                                </div>

                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <h4>Call For Researchers</h4>

                                    <p>
                                        We seek volunteer <b>Researchers in Residence </b> who would want to solve
                                        Africa's topmost problems. The Benefits are mostly the Papers published with us,
                                        IPs co-owned with us.
                                    </p>

                                    <p>
                                        These are internal Research and Development Professors, doctors who will also be
                                        available to mentor Junior researchers and Intens as well as handle
                                        collaborations with External Researchers.
                                    </p>

                                    <p>
                                        The Goal is to be Africa’s Topmost Private Research Lab Institution, bringing
                                        out Top most research solutions for African Problems.
                                        The Researches we conduct here, are presented for Global Fundings and as well
                                        the products are are commercialized and earn Shared Dividends
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LabMakerSpace',
        metaInfo: {
            title: "Tribinnov Africa - R&D Labs and Makers Space",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>